module.exports = __webpack_public_path__ + "static/media/Pregnant women.8251b440.svg";